<template>
  <div id="home-box">
    <el-container>
      <!--顶部菜单-->
      <el-header style="background: #0d55a4;">
          <div class="wel-box">
              <div class="top-box">
                  <el-row type="flex" align="middle" style="width: 100%">
                      <el-col :span="4" style="text-align: center">
                          <div class="wel-logo cursor" @click="jumpToWelPage">
                              <img class="cursor" style="width: 60px;height: 60px;" src="../assets/hy_logo.png" alt="">
                              恒岳教研
                          </div>
                      </el-col>
                      <el-col :span="17">

                          <el-menu mode="horizontal"
                                   background-color="transparent"
                                   active-background-color="#0d55a4"
                                   :default-active="activePath"
                                   text-color="#ffffff"
                                   active-text-color="#ffbf6b"
                                   @select="handleSelect">
                              <el-menu-item index="welHome" @click="goHome">
                                  <div>
                                      管理中心
                                  </div>
                              </el-menu-item>
                              <el-menu-item index="famousCourseManage" @click="saveNavState('famousCourseManage')">
                                  <div>
                                      资源中心
                                  </div>
                              </el-menu-item>
                              <el-menu-item index="lessonManage" @click="saveNavState('lessonManage')">
                                  <div>
                                      一体化教研
                                  </div>
                              </el-menu-item>
                              <el-menu-item index="teachActiManage" @click="saveNavState('teachActiManage')" >
                                  <div>
                                      教科研
                                  </div>
                              </el-menu-item>
                              <el-menu-item index="teacherTrainManage" @click="saveNavState('teacherTrainManage')">
                                  <div>
                                      师资培训
                                  </div>
                              </el-menu-item>
                              <el-menu-item index="famousPrincipal" @click="saveNavState('famousPrincipal')">
                                  <div>
                                      名校长工作室
                                  </div>
                              </el-menu-item>
                              <el-menu-item index="teachStudio" @click="saveNavState('teachStudio')">
                                  <div>
                                      名师工作室
                                  </div>
                              </el-menu-item>
                              <el-menu-item v-if="role === 1 || role === 2 || ((role === 3 || (isCheckAuth && isCheckAuth === 1))&&userSchoolList&&userSchoolList.length!==0)"
                                            index="fileManagement" @click="saveNavState('fileManagement')">
                                  <div>
                                      档案管理
                                  </div>
                              </el-menu-item>
                          </el-menu>
                      </el-col>
                      <!--已登录-->
                      <el-col :span="2" >
                          <el-row justify="end" type="flex" align="middle">
                              <el-col :span="23" :xl="23">
                                  <div class="tr-img">
                                      <el-badge :is-dot="messageBol" style="margin-top: 4px">
                                          <img class="cursor" style="width: 18px;height: 20px" @click="toPage('personApp', 'taskmsg')"  src="../assets/homePage/rw.png"
                                               alt="任务中心">
                                      </el-badge>
                                      <el-badge :is-dot="systemBol" class="item">
                                          <img class="cursor" style="width: 20px;height: 22px" @click="toPage('personApp', 'usermsg')" src="../assets/homePage/xx.png"
                                               alt="消息中心">
                                      </el-badge>

                                      <el-dropdown class="cursor">
                                          <el-avatar style="margin-left: 15px;" :size="30" :src="userInfo.avatar + '?_=' + Date.now()" />
                                          <template #dropdown>
                                              <el-dropdown-menu>
                                                  <el-dropdown-item style="text-align: center;" @click="toPage('personApp', 'userInfo')">个人资料</el-dropdown-item>
                                                  <el-dropdown-item style="text-align: center;" @click="userLogout">安全退出</el-dropdown-item>
                                              </el-dropdown-menu>
                                          </template>
                                      </el-dropdown>
                                  </div>
                              </el-col>
                          </el-row>
                      </el-col>
                  </el-row>
              </div>
          </div>
      </el-header>

      <el-container>
        <el-aside class="lftop" :style="isActive ? 'width:0px;' : 'width: 200px;'">
          <el-menu :collapse-transition="false"
                   :collapse="isActive"
                   class="side-menu"
                   router
                   unique-opened
                   active-text-color="#ffbf6b"
                   :default-active="activeSecondPath"
                   background-color="#6e99c8"
                   text-color="#fff"
                   @open="handleOpen" @close="handleClose">
              <template v-for="item in menusList[activePath]" :key="item.path">
                  <el-menu-item
                    v-if="menuIsChildren(item)"
                    :route="{ path: item.path, query: item.query }"
                    :index="item.path" @click="saveSecondNavState(item.path)">
                      <span class="menu-title">{{ item.title }}</span>
                  </el-menu-item>
                  <el-sub-menu v-else :index="item.path">
                      <template #title><span class="menu-title">{{ item.title }}</span></template>
                      <el-menu-item v-for="m in item.children" :index="m.path" :key="m.path">{{ m.title }}</el-menu-item>
                  </el-sub-menu>
              </template>
          </el-menu>
        </el-aside>

        <!--展示区-->
        <el-main style="overflow-y: hidden">
          <div class="cursor" @click="toggleClick"
               style="position: absolute;top: 50%;transform: translateY(-50%);">
            <img style="width: 18px;"
                 :src="isActive ? require('../assets/homePage/toZk.png') : require('../assets/homePage/toSx.png')" alt="">
          </div>
          <router-view v-slot="{ Component, route }">
            <keep-alive :include="cachedViews">
              <component @changeInfo="changeInfo" @changeImg="changeAvater" :key="route.name" :is="Component"
                @changeCtMessage="getMessage" v-if="$route.meta.keepAlive" />
            </keep-alive>
            <component @changeInfo="changeInfo" @changeImg="changeAvater" :key="route.name" :is="Component"
              @changeCtMessage="getMessage" v-if="!$route.meta.keepAlive" />
          </router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'

import global from "@/utils/global"
import Screenfull from '@/components/Screenfull'
import Breadcrumb from '@/components/Breadcrumb'
import { querySchoolList, oauthCode } from "@/api/user/login";
import TagsView from '@/components/TagsView/index.vue'
import { userMessages, } from "@/api/admin/message"
import {orgListUserSchool} from "@/api/admin/public";
import SidebarItem from "@/views/testMenu.vue";

export default {
  components: {
      SidebarItem,
    Screenfull,
    Breadcrumb,
    TagsView
  },
  name: "groupHome",
  data() {
    return {
      schoolId: '',
      schoolList: [],
      userSchoolList: [],
      showChangeCampus: false,
      activePath: "",
      activeSecondPath: "",
      userHeadImg: "",
      userInfo: {},
      menusList: {
        systemManage: [
          { title: '用户配置', path: 'uesrAiConfig', icon: 'noteBook' },
          { title: '新闻资讯', path: 'news', icon: 'noteBook' },
          { title: '头部banner', path: 'banner', icon: 'noteBook' },
          { title: '活动banner', path: 'bannerNotice', icon: 'noteBook' },
          { title: '工作简报', path: 'workBrieManage', icon: 'noteBook' },
        ],
        personApp: [
          { title: '个人资料', path: 'userInfo', icon: 'noteBook' },
          { title: '消息中心', path: 'usermsg', icon: 'noteBook' },
          { title: '任务中心', path: 'taskmsg', icon: 'noteBook' },
          { title: '教师档案', path: 'teacherArchives', icon: 'noteBook' },
          { title: '成长中心', path: 'growthCenter', icon: 'noteBook' },
          { title: '课程收藏', path: 'collectionCenter', icon: 'noteBook' },
          { title: '我的关注', path: 'myFollow', icon: 'noteBook' }
        ],
        famousCourseManage: [
          { title: '高水平示范课', path: 'famousGspList', icon: 'noteBook', query: { stageType: 1 } },
          { title: '区本课程', path: 'famousQbList', icon: 'noteBook', query: { stageType: 2 } },
          { title: '校本课程', path: 'famousJbList', icon: 'noteBook', query: { stageType: 3 } },
          { title: '课后服务', path: 'famousKhList', icon: 'noteBook', query: { stageType: 4 } },
          { title: '人工智能', path: 'famousAIList', icon: 'noteBook', query: { stageType: 5 } },
          { title: '互动课件', path: 'coursewareList', icon: 'noteBook' },
          { title: '恒岳助教', path: 'ldzy', icon: 'noteBook' },
          { title: '国家智慧教育平台', path: 'gjb', icon: 'noteBook' },
        ],
        lessonManage: [
          // { title: '一体化教研统计', path: 'ptStatistics', icon: 'noteBook' },
          { title: '一体化教研统计', path: 'teachingStat', icon: 'noteBook' },
          { title: '个人备课', path: 'myLess', icon: 'noteBook' },
          { title: '协同备课', path: 'lesson', icon: 'noteBook' },
          { title: '已发布备课', path: 'lessttShare', icon: 'noteBook' },
          { title: '听评课', path: 'evaluation', icon: 'noteBook' },
          { title: '教师助手', path: 'zbnote', icon: 'noteBook' },
          { title: '作业管理', path: 'zuoye', icon: 'noteBook' },
        ],
        teachActiManage: [
          { title: '教科研统计', path: 'jkyStatistics', icon: 'noteBook' },
          { title: '课题引领', path: 'topic', icon: 'noteBook' },
          { title: '教研赛事', path: 'race', icon: 'noteBook' },
          { title: '专题活动', path: 'activity', icon: 'noteBook' },
        ],
        teacherTrainManage: [
            { title: '任务管理', path: 'train', icon: 'noteBook' },
            { title: '培训课程', path: 'traCourseList', icon: 'noteBook' },
            { title: '培训统计', path: 'trainStat', icon: 'noteBook' },
        ],
        famousPrincipal: [
            { title: '概况', path: 'rectorState', icon: 'noteBook' },
            { title: '工作室查询', path: 'rectorStudio', icon: 'noteBook' },
            { title: '工作室管理', path: 'rectorStudioManager', icon: 'noteBook' },
        ],
        teachStudio: [
            { title: '概况', path: 'teaState', icon: 'noteBook' },
            { title: '工作室查询', path: 'teaStudio', icon: 'noteBook' },
            { title: '工作室管理', path: 'teaStudioManage', icon: 'noteBook' },
        ],
        fileManagement: [],
        customerManage: [{ title: '群组维护', path: 'groupSet', icon: 'noteBook' },],
      },
      accountList: [],
      account: {},
      global: global,
      logoTextWidth: 200,   // 左上角logo文字宽度
      isActive: false,      // 是否菜单折叠
      isAuth: this.$storage.get('isAuth'),
      isSuperAuth: this.$storage.get('isSuperAuth'),
      issuedBookAuth: this.$storage.get('issuedBookAuth'),
      popname: '',
      messageBol: false,
      systemBol: false,
      isSetInter: null,
      role: 1,
        isAnalyse: this.$storage.get("isAnalyse"),
      isCheckAuth: null,
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },

  },
  watch: {
    $route(to, from) {},
  },
  created() {
    clearInterval(this.$store.state.zdy.isSetInter1)
    clearInterval(this.$store.state.zdy.isSetInter2)
    this.getMessage()
    this.getSchoolList()
    this.$store.state.zdy.isSetInter2 = setInterval(() => {
      this.getMessage()
    }, 30000)
    this.userInfo = JSON.parse(this.$storage.get("userInfo"))
    this.isCheckAuth = this.userInfo.isCheckAuth
    this.$store.commit("zdy/setRole", this.$storage.get("role"));
    this.role = this.$storage.get("role")
    if (this.$storage.get("role") == 1 || this.$storage.get("role") == 2) {
      this.menusList.systemManage.unshift({ title: '组织', path: 'arrayMaintenance', icon: 'noteBook' }, { title: '群组', path: 'teachResearch', icon: 'noteBook' }, { title: '用户', path: 'uesrManage', icon: 'noteBook' })
      this.menusList.systemManage.forEach(e => {
        e.title = e.title + '管理'
      })
      this.menusList.famousCourseManage.push(
        {
            title: '人文美育', path: 'videoLibraryManage', icon: 'noteBook',
            children:[
                // { title: '五馆合一', path: 'humanityLibrary', icon: 'noteBook' },
                { title: '视频库管理', path: 'videoLibraryManage', icon: 'noteBook' },
                // { title: '课程管理', path: 'humanityCourseManager', icon: 'noteBook' },
            ]
        },
      )
        this.menusList.famousCourseManage.push(
          {
              title: '学校文化中心管理', path: 'schoolManage', icon: 'noteBook',
              children:[
                  { title: '党建引领管理', path: 'dangj', icon: 'noteBook' },
                  { title: '政策法规管理', path: 'zhengc', icon: 'noteBook' },
                  { title: '校园安全-政策', path: 'schoolSafe', icon: 'noteBook' },
                  { title: '校园安全-视频', path: 'schoolSafeVideo', icon: 'noteBook' },
                  { title: '心理健康-政策', path: 'mentalHealth', icon: 'noteBook' },
                  { title: '心理健康-视频', path: 'mentalHealthVideo', icon: 'noteBook' },
                  // { title: '美育浸润管理', path: 'myjr', icon: 'noteBook' },
                  // { title: '五馆主题活动管理', path: 'event', icon: 'noteBook' },
                  // { title: '劳动实践活动管理', path: 'practice', icon: 'noteBook' },
                  // { title: '恒岳阅读-推荐书目', path: 'book', icon: 'noteBook' },
                  { title: '学校文化-素材中心', path: 'material', icon: 'noteBook' },
              ]
          },
        )
        this.menusList.famousCourseManage.push(
          {
              title: '学生成长中心管理', path: 'teacherManage', icon: 'noteBook',
              children:[
                  // { title: '初中题库(日清周结)', path: 'rqzj', icon: 'noteBook' },
                  // { title: '高中题库(三层量分定做)', path: 'sclfdz', icon: 'noteBook' },
                  { title: '圈考点', path: 'examPoint', icon: 'noteBook' },
                  { title: '热搜题', path: 'hotQues', icon: 'noteBook' },
                  { title: '分层作业', path: 'homeworkManager', icon: 'noteBook' },
                  { title: '英语强化', path: 'englishImprove', icon: 'noteBook' },
                  { title: '赢在录取-学霸讲专业', path: 'profession', icon: 'noteBook' },
                  { title: '赢在录取-专业知晓', path: 'professionKnowledge', icon: 'noteBook' },
                  { title: '赢在规划', path: 'admission', icon: 'noteBook' },
              ]
          },
        )
        this.menusList.famousCourseManage.push(
          { title: '资源管理', path: 'famousCourse', icon: 'noteBook' },
        )
      this.menusList.famousCourseManage.push(
        { title: '课件管理', path: 'courseware', icon: 'noteBook' },
      )




        // this.menusList.famousCourseManage.push(
        //   { title: '党建引领管理', path: 'dangj', icon: 'noteBook' },
        // )
        // this.menusList.famousCourseManage.push(
        //   { title: '政策法规管理', path: 'zhengc', icon: 'noteBook' },
        // )
        // this.menusList.famousCourseManage.push(
        //   { title: '美育浸润管理', path: 'myjr', icon: 'noteBook' },
        // )
      this.menusList.fileManagement.push({ title: '教师档案', path: 'fileList', icon: 'noteBook' })
        this.menusList.teachActiManage.push(
          { title: '成果管理', path: 'achieve', icon: 'noteBook' },
        )
        this.menusList.teachActiManage.push(
          { title: '教学分析', path: 'courseAnalyse', icon: 'noteBook' },
        )
        this.menusList.teachActiManage.push(
          { title: '教学分析管理', path: 'analyseAdmin', icon: 'noteBook' },
        )
    }
      this.isAnalyse=this.$storage.get("isAnalyse");
    if (this.$storage.get("role") === '3') {
      this.menusList.systemManage.unshift(
        { title: '组织管理', path: 'arrayMaintenance', icon: 'noteBook' },
        { title: '群组管理', path: 'teachResearch', icon: 'noteBook' }
        , { title: '用户管理', path: 'uesrManage', icon: 'noteBook' }
      )
        if (this.isAnalyse === '1') {
            this.menusList.teachActiManage.push(
              { title: '教学分析', path: 'teachAnalyse', icon: 'noteBook' },
            )
        }
    }
    if (this.$storage.get("role") == 1 || this.$storage.get("role") == 2 || this.$storage.get("role") == 3) {
      this.menusList.systemManage.push({ title: '教程库管理', path: 'classLibrary', icon: 'noteBook' })
      this.menusList.teacherTrainManage.push({ title: '课程管理', path: 'traCourse', icon: 'noteBook' })
      this.menusList.famousPrincipal.splice(1,0,{ title: '工作室统计', path: 'principalStudio', icon: 'noteBook' })
      //this.menusList.famousPrincipal.unshift({ title: '工作室统计', path: 'principalStudio', icon: 'noteBook' })
      this.menusList.teachStudio.splice(1,0,{ title: '工作室统计', path: 'msgzsStatistics', icon: 'noteBook' })
      this.menusList.lessonManage.splice(3, 0, { title: '备课审核', path: 'shareApply', icon: 'noteBook' })
      this.menusList.fileManagement.push({ title: '档案分配', path: 'fileAllocation', icon: 'noteBook' })
      this.menusList.fileManagement.push({ title: '档案填报管理', path: 'fileManage', icon: 'noteBook' })
      this.menusList.fileManagement.push({ title: '设置档案审核员', path: 'setFileCheck', icon: 'noteBook' })
    }
    if (this.isCheckAuth && this.isCheckAuth == 1) {
      this.menusList.fileManagement.push({ title: '档案审核', path: 'checkList', icon: 'noteBook' })
    }
    if (this.$storage.get("role") == 4 || this.$storage.get("role") == 5) {
      this.menusList.systemManage.push({ title: '教程库管理', path: 'classLibrary', icon: 'noteBook' })
      this.menusList.famousPrincipal.unshift({ title: '工作室统计', path: 'principalStudio', icon: 'noteBook' })
      this.menusList.teachStudio.unshift({ title: '名师工作室统计', path: 'msgzsStatistics', icon: 'noteBook' })
    }
    this.logoTextWidth = window.innerWidth * (20 / 100);
    this.watchWidth();
    if (window.sessionStorage.getItem('activePath') && window.sessionStorage.getItem('activePath') != 'undefined') {
      this.activePath = window.sessionStorage.getItem('activePath')
    } else {
      this.activePath = Object.keys(this.menusList)[0]
      window.sessionStorage.setItem('activePath', Object.keys(this.menusList)[0])
    }
    if (window.sessionStorage.getItem('activeSecondPath') && window.sessionStorage.getItem('activeSecondPath') != 'undefined') {
      this.activeSecondPath = window.sessionStorage.getItem('activeSecondPath')
    } else {
      this.activeSecondPath = this.menusList[Object.keys(this.menusList)[0]][0].path
      window.sessionStorage.setItem('activeSecondPath', this.menusList[Object.keys(this.menusList)[0]][0].path)
    }
    if (this.activeSecondPath == 'famousGspList') {
      this.replace('/' + this.activeSecondPath, { stageType: 1 })
    } else {
      this.replace('/' + this.activeSecondPath)
    }

    this.popname = JSON.parse(this.$storage.get("userInfo")).trueName
    this.userHeadImg = JSON.parse(this.$storage.get("userInfo")).avatar
  },
  mounted() {
    // 监听网页大小
    window.onresize = () => {
      return (() => {
        this.watchWidth();
        this.logoTextWidth = window.innerWidth * (20 / 100);
      })();
    };
  },
  methods: {
    getMessage() {
      userMessages({ code: 1 }).then(res => {
        this.systemBol = false;
        res.data.data.forEach(e => {
          if (e.isRead == 0) {
            this.systemBol = true;
          }
        })
      });
      userMessages().then(res => {
        this.messageBol = false;
        res.data.data.forEach(e => {
          if (e.isRead == 0) {
            if (e.code != 1) {
              this.messageBol = true;
            }
          }
        })
      });
    },
    changeAvater(e) {
      this.userHeadImg = null;
      this.userHeadImg = e;
    },
    changeInfo(e) {
      this.popname = JSON.parse(this.$storage.get("userInfo")).trueName
      this.userHeadImg = JSON.parse(this.$storage.get("userInfo")).avatar
    },
    openJs() {
      var openUrl = 'zbnote:' + this.$storage.get("token")
      var _this = this;
      window.sessionStorage.setItem('activeSecondPath', _this.menusList[_this.activePath][0].path)
      this.activeSecondPath = _this.menusList[_this.activePath][0].path
      _this.$router.push({ path: '/' + _this.menusList[_this.activePath][0].path });
      window.protocolCheck(openUrl, () => {
        ElMessageBox.confirm(
          '检测到未安装客户端，请确认是否下载?',
          '下载',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            window.open('https://hengyuejy.com/aide/ZBnote.exe', '_blank')

          })
          .catch(() => {
            _this.$router.push({ path: '/' + _this.menusList[_this.activePath][0].path });
          })
      });
    },
    handleSelect(key, keyPath) {},
    changeshowChangeCampus() {
      querySchoolList().then(res => {
        this.schoolList = res.data.data;
        this.schoolId = Number(this.$storage.get("schoolId"))
        this.showChangeCampus = true;
      })
    },
    changeSchool() {
      this.schoolList.forEach(e => {
        if (e.schoolId == this.schoolId) {
          this.$storage.set('schoolName', e.schoolName);
          this.$storage.set('schoolId', e.schoolId);
        }
      })
      this.showChangeCampus = false;
      console.log(this.schoolId)
    },
    // 监听网页大小
    watchWidth() {
      if (window.innerWidth < 1000) {
        this.isActive = true;
        this.$store.commit("zdy/setIsActive", true);
      } else {
        this.isActive = false;
        this.$store.commit("zdy/setIsActive", false);
      }
    },
    toggleClick() {
      setTimeout(() => {
        this.isActive = !this.isActive;
        this.$store.commit("zdy/setIsActive", this.isActive);
        console.log(this.$store.state.zdy.isActive)
      }, 10)

    },
    handleOpen: function () { },
    handleClose: function () { },
    changeGroup(account) {
      this.account = account
      this.$storage.set("lastGroupAccount", JSON.stringify(account));
      this.$addStorageEvent("saasGroup", account);
    },
    goHome() {
      this.$router.push({ path: '/hyedu/home' });
    },
    // 保存链接的激活状态
    saveNavState(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
      if (this.menusList[this.activePath][0].query) {
        this.$router.push({ path: '/' + this.menusList[this.activePath][0].path, query: this.menusList[this.activePath][0].query });
      } else {
        this.$router.push({ path: '/' + this.menusList[this.activePath][0].path });
      }
      this.saveSecondNavState(this.menusList[this.activePath][0].path)
    },
    saveSecondNavState(activePath) {
      if (activePath == 'zbnote') {
        this.openJs()
        return;
      } else if (activePath == 'ldzy') {
        window.sessionStorage.setItem('activeSecondPath', this.menusList[this.activePath][0].path)
        this.activeSecondPath = this.menusList[this.activePath][0].path
        this.$router.push({ path: '/' + this.menusList[this.activePath][0].path, query: { stageType: 1 } });
        if (!this.userInfo.isAide) {
          this.$message.error("暂无权限")
        } else {
          oauthCode({
            clientId: 'xhly2024855631', username: this.userInfo.username
          }).then(res => {
            if (res.data.data) {
              window.open('https://web.edumate.cn/thirdpart?platform=sxdtjz&code=' + res.data.data + '&client_id=xhly2024855631&response_type=code', '_blank')
            } else {
              this.$message.error("授权失败")
            }
          })
        }
      } else if (activePath == 'rwmy') {
        window.sessionStorage.setItem('activeSecondPath', this.menusList[this.activePath][0].path)
        this.activeSecondPath = this.menusList[this.activePath][0].path
        this.$router.push({ path: '/' + this.menusList[this.activePath][0].path, query: { stageType: 1 } });
        window.open('https://m.boyameiyu.com/', '_blank')
      } else if (activePath == 'gjb') {
        window.sessionStorage.setItem('activeSecondPath', this.menusList[this.activePath][0].path)
        this.activeSecondPath = this.menusList[this.activePath][0].path
        this.$router.push({ path: '/' + this.menusList[this.activePath][0].path, query: { stageType: 1 } });
        window.open('https://basic.smartedu.cn/', '_blank')
      } else if (activePath == 'zuoye') {
            window.sessionStorage.setItem('activeSecondPath', this.menusList[this.activePath][0].path)
            this.activeSecondPath = this.menusList[this.activePath][0].path
            this.$router.push({ path: '/' + this.menusList[this.activePath][0].path, query: { stageType: 1 } });
            window.open('https://orgzuoye.slilm.com/', '_blank')
        } else {
        window.sessionStorage.setItem('activeSecondPath', activePath)
        this.activeSecondPath = activePath
      }
    },
    toPage(activePath, activeSecondPath) {
      window.sessionStorage.setItem('activePath', activePath)
      window.sessionStorage.setItem('activeSecondPath', activeSecondPath)
      this.activePath = activePath;
      this.activeSecondPath = activeSecondPath
      this.$router.push({ path: activeSecondPath });
    },
      userLogout() {
      this.$confirm("您正在退出系统，是否继续？", "退出系统", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          this.$storage.remove("token")
          this.$storage.remove("userInfo")
          this.$storage.remove("role");
          this.$storage.remove("isLogin");
          this.$router.push({ path: "/hyedu/wel" });
      })
    },
    toHome() {
      this.$router.push("/hyedu/home")
    },
    userCenter() {
      this.$router.push("/user")
    },
    getSchoolList(){
          orgListUserSchool().then(res => {
              this.userSchoolList = res.data.data;
          })
      },
      jumpToWelPage(){
          this.$router.push({ path: "/hyedu/wel" });
      },
      menuIsChildren(item){
          return !(item.children && item.children.length > 0);

      }
  }
}
</script>
<!--内联样式-->
<style lang="scss" scoped>
.tr-img {
    display: flex;
    align-items: center;
    justify-content: end;

    img {
        width: 20px;
        height: 24px;
        margin-left: 15px;
    }
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: #c2c0c0;
}

/deep/ .el-menu-item:hover {
    color: #ffffff;
}

/deep/ .el-menu--collapse .el-sub-menu.is-active .el-sub-menu__title {
    color: var(--el-menu-active-color) !important;
}

/deep/ .top-tp .el-menu-item .is-active {
    border-bottom: 2px solid #ffbf6b !important;
}

/* 左侧菜单列表 */
/deep/ .lftop .el-menu {
    padding: 6px 0;
}

/deep/ .lftop .el-menu-item,
/deep/ .lftop .el-sub-menu__title {
    height: 44px;
    line-height: 44px;
    margin: 4px 8px;
    border-radius: 6px;
    color: #f2f7fd;
    font-size: 14px;
    transition: background-color .2s, color .2s;
}

/deep/ .lftop .el-menu-item:hover,
/deep/ .lftop .el-sub-menu__title:hover {
    background-color: rgba(255, 255, 255, 0.14);
    color: #ffffff;
}

/deep/ .lftop .el-menu-item.is-active {
    background: #0d55a4;
    color: #fff;
    font-weight: 600;
    position: relative;
}

/* 左侧菜单列表 */
/deep/ .lftop .el-menu {
    padding: 6px 0;
}

/deep/ .lftop .el-menu-item,
/deep/ .lftop .el-sub-menu__title {
    height: 44px;
    line-height: 44px;
    margin: 4px 8px;
    border-radius: 6px;
    color: #fff;
    font-size: 14px;
    transition: background-color .2s, color .2s;
}

/deep/ .lftop .el-menu-item:hover,
/deep/ .lftop .el-sub-menu__title:hover {
    background-color: rgba(255, 255, 255, 0.14);
    color: #0d55a4;
}

/deep/ .lftop .el-menu-item.is-active {
    background: #0d55a4;
    color: #ffbf6b;
    font-weight: 600;
    position: relative;
}

/deep/ .lftop .el-menu-item.is-active::after {
    content: '';
    position: absolute;
    left: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 40%;
    border-radius: 2px;
    background-color: #ffbf6b;
}

/deep/ .lftop .el-menu-item.is-active i {
    color: #ffbf6b !important;
}

/* 子菜单 */
/deep/ .lftop .el-sub-menu.is-active .el-sub-menu__title {
    color: #ffbf6b;
    font-weight: 600;
    background-color: rgba(0, 0, 0, 0.12);
}

/deep/ .lftop .el-sub-menu .el-menu--inline {
    background: rgba(0, 0, 0, 0.08);
    border-radius: 6px;
}

/deep/ .lftop .el-sub-menu .el-menu--inline .el-menu-item {
    height: 40px;
    line-height: 40px;
    margin: 2px 0;
}

/deep/ .el-menu-item.is-active::after {
    background: #0d55a4;
    position: absolute;
    right: 0;
    height: 100%;
    width: 2px;
}

.hamburgerBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
}

.hamburger {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    cursor: pointer;
    color: #e7efff;
}

.hamburger.is-active {
    transform: rotate(180deg);
}

.zbh-logo {
    height: 60px;
    line-height: 60px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    span {
        white-space: nowrap;
        font-size: 24px;
    }
    div {
        font-size: 24px;
    }

    img {
        width: 25px;
        padding: 0 10px;
    }
}

#home-box {
    width: 100%;
    height: 100%;
    .el-menu--horizontal {
        border-color: transparent;
        height: 60px;
    }
    .el-main {
        padding: 0 !important;
        background: #f1f1f1;
    }

    .el-container {
        height: 100%;
    }

    .el-aside {
        width: 20%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 100%;
        background: #f1f1f1;
        overflow: hidden;
        .zbh-logo {
            height: 8%;
            color: #F9F8F8;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: justify;
            background-color: #20222a;
        }

        .el-menu {
            border-top-right-radius: 6px;
            border: none;
            margin-top: 10px;
            height: calc(100vh - 75px);
            background-color: #6e99c8;
            color: #333;
            overflow-y: auto;
        }

    }

    .el-header {
        padding: 0 0;
        text-align: center;
        height: 70px !important;
    }
}

.schoolDrawer /deep/ .el-drawer.ttb {
    width: 20%;
    margin-left: 70% !important;
}

.scrollbar-flex-content {
    display: flex;
    height: auto !important;
}

.scrollbar-demo-item {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 50px;
    margin: 10px;
    text-align: center;
    border-radius: 4px;
    background: var(--el-color-danger-light-9);
    color: var(--el-color-danger);
}

/deep/.top-box .el-menu {
    height: 70px;
    border-bottom: none!important;
}

/deep/.top-box .el-menu-item {
    font-size: 16px;
    height: 70px;
    margin-top: -6px;
    padding: 10px 15px 10px 15px;
}
/deep/.top-box .el-menu-item.is-active {
    font-weight: 600;
    font-size: 16px;
    border-bottom: none!important;
    background-color: #0d55a4;
    div{
        height: 30px;
        line-height: 30px;
        border-bottom: 2px solid #ffbf6b !important;
    }
}

.wel-box {
    width:100vw;
    height: auto;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #0d55a4;
    }
}
.menu-box{
    height: 30px;
    line-height: 30px;

}

.tr-img {
    display: flex;
    align-items: center;
    justify-content: end;

    img {
        width: 20px;
        height: 24px;
        margin-left: 15px;
    }
}
.wel-logo{
    display: flex;
    align-items: center;
    color: #e7eef6;
    font-size: 20px;
    img {
        width: 60px;
        margin-left: 10px;
        margin-right: 10px;
    }
}
</style>
